import { excuseApi } from "../commons/http";

class ScheduledAlert {
  constructor(data = {}) {
    this.id = data.id;
    this.title = data.title;
    this.message = data.message;
    this.scheduled_at = data.scheduled_at;
    this.priority = data.priority || 'medium';
    this.status = data.status || 'pending';
    this.created_by = data.created_by;
    this.creator_name = data.creator_name;
    this.user_id = data.user_id;
    this.user_name = data.user_name;
    this.triggered_at = data.triggered_at;
    this.created_at = data.created_at;
    this.updated_at = data.updated_at;
  }

  mapData(data) {
    this.id = data.id;
    this.title = data.title;
    this.message = data.message;
    this.scheduled_at = data.scheduled_at;
    this.priority = data.priority || 'medium';
    this.status = data.status || 'pending';
    this.created_by = data.created_by;
    this.creator_name = data.creator_name;
    this.user_id = data.user_id;
    this.user_name = data.user_name;
    this.triggered_at = data.triggered_at;
    this.created_at = data.created_at;
    this.updated_at = data.updated_at;
  }

  async createAlert() {
    const res = await excuseApi({
      path: '/scheduled-alerts',
      method: 'POST',
      body: {
        title: this.title,
        message: this.message,
        scheduled_at: this.scheduled_at,
        priority: this.priority,
        user_id: this.user_id,
      }
    });
    if (res.status === 200 || res.status === 201) {
      return { success: true, message: "Alert created successfully", id: res.data.data.id };
    }
    return { success: false, message: "Failed to create alert" };
  }

  async updateAlert(id) {
    const res = await excuseApi({
      path: `/scheduled-alerts/${id}`,
      method: 'PUT',
      body: {
        title: this.title,
        message: this.message,
        scheduled_at: this.scheduled_at,
        priority: this.priority,
        user_id: this.user_id,
      }
    });
    if (res.status === 200 || res.status === 201) {
      return { success: true, message: "Alert updated successfully" };
    }
    return { success: false, message: "Failed to update alert" };
  }

  async getAlertById(id) {
    const res = await excuseApi({
      path: `/scheduled-alerts/${id}`,
      method: 'GET',
    });
    if (res.status === 200) {
      this.mapData(res.data.data);
      return { success: true };
    }
    return { success: false, message: "Alert not found" };
  }
}

export default ScheduledAlert;
